import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainAmazonSliceDTO } from './types'

export const DOMAIN_AMAZON_FRAGMENT: TypedDocumentNode<DomainAmazonSliceDTO> = gql`
  fragment DomainAmazonFragment on DomainAmazon {
    enabled
    id
    domain {
      name
    }
  }
`
